import { isSameWeek, parseISO } from 'date-fns';
import type { OpenSite } from '../../services/scheduleService';

/**
 * Which of the inspector's open sites belong in the schedule's "Due, not
 * scheduled" list — the only place with an Add-to-day button.
 *
 * JIM-0929-12 (Jim 2026-09-29): a site he had just claimed never showed up
 * there. Two reasons, both fixed here and on the server: the list only held
 * overdue / due-this-week sites, and a recently inspected claim is neither;
 * and the query behind it was not refreshed after a claim.
 */
export function isDueThisWeek(site: OpenSite, now = new Date()): boolean {
  if (!site.next_inspection_date) return true;
  // isThisWeek has no `now` option (the old spread did nothing and the specs
  // broke the Monday the real week reached their fixture's date, 2026-10-19).
  return isSameWeek(parseISO(site.next_inspection_date), now, {
    weekStartsOn: 1,
  });
}

export function isAttentionSite(
  site: OpenSite,
  scheduledSiteIds: Set<string>,
  now = new Date()
): boolean {
  if (scheduledSiteIds.has(site.id)) return false;
  return !!site.just_claimed || site.is_overdue || isDueThisWeek(site, now);
}

/** The one-line status under the site name in that list. */
export function attentionLabel(site: OpenSite, now = new Date()): string {
  if (site.is_overdue) return `${site.days_overdue} days overdue`;
  if (site.just_claimed && !isDueThisWeek(site, now))
    return 'Just claimed — pick a day';
  return 'Due this week';
}
